import React, { CSSProperties, useMemo } from "react"
// import { useDoubleTap } from "src/shared/hooks/useHandleDoubleTap"
import { RoomStatusProps } from "./interfaces/RoomStatusProps.interface"
import { RoomStatus } from "./enums/RoomStatus.enum"
import { useProfile } from "src/shared/hooks/useProfile"

import "./RoomCard.css"
import RoomCardLG from "./RoomCardLG/RoomCardLG"
import RoomCardMD from "./RoomCardMD/RoomCardMD"
import RoomCardMXL from "./RoomCardMXL/RoomCardMXL"
import RoomCardSM from "./RoomCardSM/RoomCardSM"
import RoomCardXL from "./RoomCardXL/RoomCardXL"
import RoomCardXS from "./RoomCardXS/RoomCardXS"
import { RoleNames } from "src/shared/hooks/useAuth"

export type RoomCardSizes = "xs" | "sm" | "md" | "lg" | "mxl" | "xl"

export interface RoomCardProps extends RoomStatusProps {
    size: RoomCardSizes
    isSelected?: boolean
    onSelect?: () => void
    style?: CSSProperties
}

// Estados que nunca abren el detalle, sin importar el rol
const NON_CLICKABLE_STATUSES = [RoomStatus.apartada]

const VALET_CLICKABLE_STATUSES = [
    RoomStatus.occupied,
    RoomStatus.roomService,
    RoomStatus.reserved,
    RoomStatus.available,
    RoomStatus.clean,
]

const ROOM_SERVICE_CLICKABLE_STATUSES = [RoomStatus.occupied]

const RoomCard = ({ size, isSelected, onSelect = undefined, ...props }: RoomCardProps) => {
    const { rolName } = useProfile()

    const getIsClickable = () => {
        if (NON_CLICKABLE_STATUSES.includes(props.roomStatus)) {
            return false
        }
        if (rolName === RoleNames.valet) {
            return VALET_CLICKABLE_STATUSES.includes(props.roomStatus)
        }
        if (rolName === RoleNames.roomService) {
            return ROOM_SERVICE_CLICKABLE_STATUSES.includes(props.roomStatus)
        }
        return true
    }

    const isClickable = getIsClickable()

    // const doubleTapHandler = useDoubleTap(() => {
    //     setTimeout(() => {
    //         onSelect?.()
    //     }, 10);
    // })

    const cardSize = useMemo(() => {
        switch (size) {
            case "xl":
                return <RoomCardXL {...props} isSelected={isSelected} />
            case "lg":
                return <RoomCardLG {...props} isSelected={isSelected} />
            case "md":
                return <RoomCardMD {...props} isSelected={isSelected} />
            case "sm":
                return <RoomCardSM {...props} isSelected={isSelected} />
            case "xs":
                return <RoomCardXS {...props} isSelected={isSelected} />
            case "mxl":
                return <RoomCardMXL {...props} isSelected={isSelected} />
            default:
                return <></>
        }
    }, [size, props])

    return (
        <div className="room-card" style={{ ...props.style }} onClick={isClickable ? onSelect : undefined}>
            {cardSize}
        </div>
    )
}

export default RoomCard
